<template>
  <div id="content" class="loginpage">
    <UserSwitcher :dialogVisible='showUserSwitcher' :list_of_user="user_list" @choiceMade="loginAs($event)"  ></UserSwitcher>

    <div class="container  text-center">

      <div class="row">
        <div class="col-12">
          <form class="login-form" >
            <img :src="require('@/assets/logo_innopearl.png')"  class="sidebar_logo mb-5" alt="">
            <div class="mb-3">
              <input type="text" id="username" placeholder="Professional email" v-model="input.username" />
            </div>
            <div class="mb-3 prelative">
              <input :type="inputtype" id="password" placeholder="Password" v-model="input.password" />
              <button type="button" class="toggleView" @click="toggleView()" name="button">
                <v-icon v-if="inputtype == 'password'" icon="mdi-eye-outline"></v-icon>
                <v-icon v-if="inputtype == 'text'"  icon="mdi-eye-off-outline"></v-icon>
              </button>
            </div>
            <button class="btn next_step_btn" type="submit" v-on:click.prevent = "login()">
              Login
            </button>
            <a @click="resetPwd()" class="forgotten_pwd">Recover password</a>

          </form>
        </div>
      </div>
    </div>
  </div>
  </template>

  <script>
  import UserSwitcher from '@/components/UserSwitcher.vue'

   import {toast } from 'vue-sonner'
   import api from '../tools/api';
  export default {
    name: 'LoginView',
    components: {
      UserSwitcher
    },
    data(){
      return{
          input:{
              username: "",
              password: ""
          },
          redirectTo :"",
          user_list : [],
          inputtype:"password",
          showUserSwitcher:false,
      }
    },
    methods: {
      toggleView(){
        if(this.inputtype == "password")this.inputtype="text";
        else this.inputtype = "password";
      },
      loginAs(v){
        console.log(v);
        if(v == -1){
          //login as user
          this.$store.commit('LOGIN',this.initialUser);
          toast.success("Welcome back to your Partner+ platform, "+this.initialUser.fullname);
          if (this.initialUser.affinityConfig) {
            this.$store.dispatch("encryptAffinityConfig", this.initialUser.affinityConfig);
          }
          api.get(process.env.VUE_APP_API_URL+"/restrict/projects").then( (r) => {
            console.log(r);
            if(this.redirectTo == "projects"){
              this.$router.push('/all_my_projects');
            }
            else if(this.redirectTo == "projects_admin"){
                this.$router.push('/admin/my_projects');
            }
            else if(this.redirectTo == "projects_expert"){
                      this.$router.push('/expert/my_projects');
            }
            else{
              this.$router.push('/myaccount');
            }

          }).catch( error => {
          console.log(error);
          console.log("oqsdof");

        });
        }
        else{
          //login as another account
          var accompagne = v;
          var loggedAs =  this.user_list.find(item => item._id.$oid === accompagne);
          toast.success("Welcome back to your Partner+ platform, "+this.initialUser.fullname+". You are connected as "+loggedAs.firstname+" "+loggedAs.lastname);

          api.post(process.env.VUE_APP_API_URL+"/acc_login",
            {
              accompagne : accompagne,
              initialUser : this.initialUser.uid.$oid
            },
            {
              headers: {
              'Content-Type': 'application/json',
            }
          }).then( (r) => {
            console.log("ACCOMPANGNAT LOGIN DATA");
            console.log(r);
            this.userc = {...this.initialUser, ...r.data};
            this.userc.loginFrom = this.initialUser.uid.$oid;
            console.log("userc",this.userc);
            this.$store.commit('LOGIN',this.userc);
            if (r.data.affinityConfig) {
              this.$store.dispatch("encryptAffinityConfig", r.data.affinityConfig);
            }
              api.get(process.env.VUE_APP_API_URL+"/restrict/projects").then( (r) => {
                console.log(r);
                this.$router.push('/all_my_projects');
              });
          });
        }

      },
      login(){
        this.axios.post(process.env.VUE_APP_API_URL+"/login",this.input,{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log("LOGIN DATA");
          console.log(r);
          console.log(r.data);
          console.log(r.data.redirectTo);
          console.log(r.data.accompagnant);
          var redirectTo = r.data.redirectTo;
          this.redirectTo = r.data.redirectTo;
          var accompagnant = r.data.accompagnant ?? [];
          if(accompagnant.length > 0){
              this.initialUser = r.data;
              this.user_list = accompagnant;
              this.showUserSwitcher = true;
          }
          else{
            this.$store.commit('LOGIN',r.data);
            toast.success("Welcome back to your Partner+ platform, "+r.data.fullname);
            if (r.data.affinityConfig) {
              this.$store.dispatch("encryptAffinityConfig", r.data.affinityConfig);
            }
            api.get(process.env.VUE_APP_API_URL+"/restrict/projects").then( (r) => {
              console.log(r);
              if(redirectTo == "projects"){
                this.$router.push('/all_my_projects');
              }
              else if(redirectTo == "projects_admin"){
                  this.$router.push('/admin/my_projects');
              }
              else if(redirectTo == "projects_expert"){
                        this.$router.push('/expert/my_projects');
              }
              else{
                this.$router.push('/myaccount');
              }

            }).catch( error => {
            console.log(error);
            console.log("oqsdof");

          });
          }

      }).catch( (error,data) => {
            console.log("error",error);
              console.log("data",data);
            var error_ok = false;
            if(error.response)
              if(error.response.data)
                if(error.response.data.message){
                  toast.error(error.response.data.message);
                  error_ok = true;
                }

            if(!error_ok){
              toast.error("Invalid email or password");


            }
          });
       //  if(this.input.username == "numeria" || this.input.password == "numeria"){
       //    this.$store.commit('LOGIN',this.input.username);
       //
       //    toast.success("Welcome "+this.input.username);
       //     this.$router.push('/');
       // }else{
       //   console.log("Username and Password can not be empty")
       //     toast.error("Invalid username or password");
       // }

     },
    resetPwd(){
       var uname = this.input.username;
       if(!uname){
         uname= prompt("Please provide your professional email to reset your password");
       }
       if(uname){
        this.axios.post(process.env.VUE_APP_API_URL+"/password_reset",{'username':uname},{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success("A password reset email has been sent to your inbox. Please check it and follow the instructions.");
        }).catch(() =>{

          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ");
        })
        }
      }
    },

    mounted(){

        this.$store.commit('LOGOUT');
    },
  }
  </script>
<style media="screen" scoped>
.loginpage{
  padding: 50px;
}
.loginpage form{
  background: #FFF;
  padding: 50px;
  border-radius: 20px;
  max-width: 600px;
margin: auto;
}

.loginpage form input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
height: 40px;
padding: 5px;
}
.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}

.forgotten_pwd,
.forgotten_pwd:hover{
  display:block;
  font-size:16px;
  text-decoration: underline;
  color:#000;
  margin-top:10px;
  cursor: pointer;
}

.sidebar_logo{
  width: 120px;

}
.prelative{
  position:relative;
}
.toggleView{
  position: absolute;
  right: 10px;
  top: 5px;
}
</style>
